export const photos = [
  {
    id: 1,
    imageUrl: 'https://images.unsplash.com/photo-1586671267731-da2cf3ceeb80?w=400',
    petName: 'Max',
    date: '2023-05-15',
    activity: 'Paseo',
    taggedPets: [1, 3],
    comments: [
      { userId: 1, text: '¡Qué bien se ve Max!', date: '2023-05-15' }
    ]
  },
  {
    id: 2,
    imageUrl: 'https://images.unsplash.com/photo-1587300003388-59208cc962cb?w=400',
    petName: 'Luna',
    date: '2023-05-14',
    activity: 'Baño',
    taggedPets: [2],
    comments: []
  }
];

export const pets = [
  { id: 1, name: 'Max', ownerId: 1, avatar: 'https://images.unsplash.com/photo-1586671267731-da2cf3ceeb80?w=100' },
  { id: 2, name: 'Luna', ownerId: 2, avatar: 'https://images.unsplash.com/photo-1587300003388-59208cc962cb?w=100' },
  { id: 3, name: 'Rocky', ownerId: 3, avatar: 'https://images.unsplash.com/photo-1583337130417-3346a1be7dee?w=100' }
];

export const users = [
  { id: 1, name: 'Juan Pérez', isStaff: false },
  { id: 2, name: 'María Gómez', isStaff: false },
  { id: 3, name: 'Carlos Admin', isStaff: true }
];